// base
import React from 'react';

// style
import { StyledTextButton } from './style';

// libraries
import { type ButtonProps } from '@mui/material';

type ButtonVariant = NonNullable<ButtonProps['variant']>;

export interface TextButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: ButtonVariant;
}

export const TextButton: React.FC<TextButtonProps> = ({ variant = 'text', children, ...props }) => {
  return (
    <StyledTextButton disableRipple variant={variant} {...props}>
      {children}
    </StyledTextButton>
  );
};
